import { updateGoal as _updateGoal } from '@griply/services';
import { UpdateGoal } from '@griply/types';
import {
  collection,
  doc,
  increment,
  serverTimestamp,
  Timestamp,
  updateDoc,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';

import { getAuthentication, getDatabase } from './helpers';

export const updateGoal = async (
  goal: UpdateGoal,
  forceValues?: boolean,
): Promise<void> => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  await _updateGoal({
    goal,
    forceValues,
    collection,
    doc,
    updateDoc,
    db: getDatabase(),
    serverTimestamp,
    timestampFromDate: (date: Date) => Timestamp.fromDate(date),
    increment,
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.UpdateGoal,
        error,
        uid: user.uid,
        docPath: `goals/${goal.id}`,
      }),
  });
};
